import { IApplicationState } from '../../types/redux';

export function selectCurrentPage(state: IApplicationState): number {
  const { filters } = state;

  return filters.page || 1;
}
